import "@mantine/core/styles.layer.css"
import "@mantine/dates/styles.layer.css"
import "@mantine/schedule/styles.layer.css"
import "@mantine/notifications/styles.layer.css"
import "@mantine/tiptap/styles.layer.css"
import "@mantine/dropzone/styles.layer.css"
import "@mantine/carousel/styles.layer.css"
import "./layers.css"

import ReactDOM from "react-dom/client"
import LocalizedFormat from "dayjs/plugin/localizedFormat"
import Duration from "dayjs/plugin/duration"
import RelativeTime from "dayjs/plugin/relativeTime"
import UTC from "dayjs/plugin/utc"
import WeekOfYear from "dayjs/plugin/weekOfYear"
import IsToday from "dayjs/plugin/isToday"
import DayOfYear from "dayjs/plugin/DayOfYear"
import dayjs from "dayjs"

import "./dayjs-load-all-locales.ts"
import "./i18n.ts"
import isoWeek from "dayjs/plugin/isoWeek"
import { App } from "./App.tsx"
import customParseFormat from "dayjs/plugin/customParseFormat"
import isSameOrAfter from "dayjs/plugin/isSameOrAfter"
import isSameOrBefore from "dayjs/plugin/isSameOrBefore"
import { ApplicationProviders } from "./ApplicationProviders.tsx"

dayjs.extend(WeekOfYear)
dayjs.extend(DayOfYear)
dayjs.extend(LocalizedFormat)
dayjs.extend(Duration)
dayjs.extend(RelativeTime)
dayjs.extend(UTC)
dayjs.extend(IsToday)
dayjs.extend(isoWeek)
dayjs.extend(customParseFormat)
dayjs.extend(isSameOrAfter)
dayjs.extend(isSameOrBefore)

if (typeof window !== "undefined") {
  const browserLocale = (navigator.language || "de-DE").toLowerCase()
  dayjs.locale(browserLocale)
}

const root = document.getElementById("root")
if (root) {
  ReactDOM.createRoot(root).render(
    <React.StrictMode>
      <ApplicationProviders>
        <App />
      </ApplicationProviders>
    </React.StrictMode>
  )
}
